
import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';
// Lazy-loaded components
const SpecialEducationPageSession = React.lazy(() => import('../departments/specialeducation/SpecialEducationPageSession'));
const SpecialEducationPageHeader = React.lazy(() => import('../departments/specialeducation/SpecialEducationPageHeader'));

function SpecialEducationPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />} jsx={true.toString()}>
       <SpecialEducationPageHeader />
       <SpecialEducationPageSession />
      </Suspense>
    </div>
  );
}

export default SpecialEducationPage;
